import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
const PlatformLayout = lazy(() =>
  import("../components/platform/PlatformLayout").then((mod) => ({ default: mod.default }))
);
const SetupLayout = lazy(() =>
  import("../components/setup/SetupLayout").then((mod) => ({ default: mod.default }))
);
const LandingLayout = lazy(() =>
  import("../components/landing/LandingLayout").then((mod) => ({ default: mod.default }))
);

// ==========================================================================================================
const index = () => {
  return (
    // <BrowserRouter>
    <Routes>
      <Route
        index
        path="/"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <LandingLayout />
          </Suspense>
        }
      />
      <Route
        path="platform"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <PlatformLayout />
          </Suspense>
        }
      />
      <Route
        path="setup"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <SetupLayout />
          </Suspense>
        }
      />
    </Routes>
    // </BrowserRouter>
  );
};

export default index;
